import './style/index.js';

import _Switch from './switch';

export type { SwitchProps } from './switch';
export * from './type';

export const Switch = _Switch;
export default Switch;
